import { render, staticRenderFns } from "./ExpendSettings.vue?vue&type=template&id=1a7ea8e2&scoped=true&"
import script from "./ExpendSettings.vue?vue&type=script&lang=js&"
export * from "./ExpendSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7ea8e2",
  null
  
)

export default component.exports